import { RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumb';

const PaymentLayout = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "PaymentLayout" */ '../layout/layout');
const FailedPayment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FailedPayment" */ '../pages/failed/failed');
const SuccessPayment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "SuccessPayment" */ '../pages/success/success');
const CancelledPayment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CancelledPayment" */ '../pages/cancelled/cancelled');
const AwaitingPayment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AwaitingPayment" */ '../pages/awaiting-payment/awaiting-payment');
const UnderProcessing = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "UnderProcessing" */ '../pages/under-processing/under-processing');

export const routes: RouteConfig[] = [
  {
    path: '/payment',
    component: PaymentLayout,
    children: [
      {
        path: 'success',
        name: 'SuccessPayment',
        component: SuccessPayment,
        meta: {
          breadcrumb: Breadcrumbs.successPayment,
          eventName: 'Success payment result page',
        },
      },
      {
        path: 'failed',
        name: 'FailedPayment',
        component: FailedPayment,
        meta: {
          breadcrumb: Breadcrumbs.failedPayment,
          eventName: 'Failed payment result page',
        },
      },
      {
        path: 'cancelled',
        name: 'CancelledPayment',
        component: CancelledPayment,
        meta: {
          breadcrumb: Breadcrumbs.cancelledPayment,
          eventName: 'Cancelled payment result page',
        },
      },
      {
        path: 'awaiting-payment',
        name: 'AwaitingPayment',
        component: AwaitingPayment,
        meta: {
          breadcrumb: Breadcrumbs.awaitingPayment,
          eventName: 'Awaiting payment result page',
        },
      },
      {
        path: 'under-processing',
        name: 'UnderProcessing',
        component: UnderProcessing,
        meta: {
          breadcrumb: Breadcrumbs.underProcessing,
          eventName: 'Under processing payment result page',
        },
      },
    ],
  },
];
